import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { type InstanceDetailDataType } from '@/api/organization';
import { useTypedAppFormContext } from '@/components/Form';
import { FieldLabel } from '@/components/Form/fields';
import { Panel } from '@/components/panels';
import { Link, Text } from '@/components/typography';
import { maxObjectNameLength } from '@/constants/numbers';

type Props = {
  instance: InstanceDetailDataType;
  isEditMode: boolean;
};

const CompanySettingsGeneralInfo = ({ instance, isEditMode }: Props) => {
  const form = useTypedAppFormContext({ defaultValues: {} as InstanceDetailDataType });

  return (
    <Panel className="h-full" title={t`General Information`}>
      <form.AppField name="name">
        {(field) => (
          <field.Field>
            <FieldLabel htmlFor="company-settings-name">
              <Trans>Company Name</Trans>
            </FieldLabel>
            {isEditMode ? (
              <field.TextInput id="company-settings-name" maxLength={maxObjectNameLength} />
            ) : (
              <Text variant="body1">{field.state.value}</Text>
            )}
            <field.Error />
          </field.Field>
        )}
      </form.AppField>
      <div className="mt-4 flex flex-col items-start gap-2">
        <FieldLabel>
          <Trans>Company Website</Trans>
        </FieldLabel>
        <Link to={`//${instance?.domain}`} color="aqua" target="_blank">
          {instance?.domain}
        </Link>
      </div>
    </Panel>
  );
};

export default CompanySettingsGeneralInfo;
